export const TypesConsultasGerais = {
    TIPOCONSULTA: "TIPOCONSULTA",
    TEXTOCONSULTA: "TEXTOCONSULTA",
    DETALHESCONSULTAGERAISPROCURAR: "DETALHESCONSULTAGERAISPROCURAR",
    DETALHESCONSULTAGERAISMOSTRAR: "DETALHESCONSULTAGERAISMOSTRAR",
    CONSULTASGERAISPROCURARRESPONSE: "CONSULTASGERAISPROCURARRESPONSE",
    CONSULTASGERAISMOSTRARRESPONSE: "CONSULTASGERAISMOSTRARRESPONSE",
    CLEARCONSULTASGERAISPROCURARRESPONSE: "CLEARCONSULTASGERAISPROCURARRESPONSE",
    CLEARCONSULTASGERAISMOSTRARRESPONSE: "CLEARCONSULTASGERAISMOSTRARRESPONSE",
    RESETCONSULTASGERAIS: "RESETCONSULTASGERAIS",
    PARAMETROPESQUISADO: "PARAMETROPESQUISADO",
    CLEARPARAMETROPESQUISADO: "CLEARPARAMETROPESQUISADO",
}

const INITIAL = {
    tipoConsultaSelecionada: -1,
    textoConsulta: '',
    pesquisado: '',
    detalhesConsultasGeraisProcurar: {},
    detalhesConsultasGeraisMostrar: {},
    consultasGeraisProcurarResponse: [],
    consultasGeraisMostrarResponse: []
}

export default function consultasGeraisReducer(state = INITIAL, action) {

    switch (action.type) {
        case TypesConsultasGerais.TIPOCONSULTA:
            return {
                ...state,
                tipoConsultaSelecionada: action.payload.tipoConsultaSelecionada
            };
        case TypesConsultasGerais.TEXTOCONSULTA:
            return {
                ...state,
                textoConsulta: action.payload.textoConsulta
            };
        case TypesConsultasGerais.PARAMETROPESQUISADO:
            return {
                ...state,
                pesquisado: action.payload.pesquisado
            };

        case TypesConsultasGerais.DETALHESCONSULTAGERAISPROCURAR:
            return {
                ...state,
                detalhesConsultasGeraisProcurar: action.payload.detalhesConsultasGeraisProcurar
            };
        case TypesConsultasGerais.DETALHESCONSULTAGERAISMOSTRAR:
            return {
                ...state,
                detalhesConsultasGeraisMostrar: action.payload.detalhesConsultasGeraisMostrar
            };
        case TypesConsultasGerais.CONSULTASGERAISPROCURARRESPONSE:
            return {
                ...state,
                consultasGeraisProcurarResponse: action.payload.response
            };
        case TypesConsultasGerais.CONSULTASGERAISMOSTRARRESPONSE:
            return {
                ...state,
                consultasGeraisMostrarResponse: action.payload.response
            };
        case TypesConsultasGerais.CLEARCONSULTASGERAISPROCURARRESPONSE:
            return {
                ...state,
                consultasGeraisProcurarResponse: []
            };
        case TypesConsultasGerais.CLEARCONSULTASGERAISMOSTRARRESPONSE:
            return {
                ...state,
                consultasGeraisMostrarResponse: []
            };
        case TypesConsultasGerais.CLEARPARAMETROPESQUISADO:
            return {
                ...state,
                pesquisado: ''
            };
        case TypesConsultasGerais.RESETCONSULTASGERAIS:
            return INITIAL;
        default:
            return state;
    }
}

export const ConsultasGeraisActions = {
    tipoConsultaSelecionada,
    textoConsulta,
    detalhesConsultasGeraisProcurar,
    detalhesConsultasGeraisMostrar,
    consultasGeraisProcurarResponse,
    consultasGeraisMostrarResponse,
    clearConsultasGeraisProcurarResponse,
    clearConsultasGeraisMostrarResponse,
    resetStateConsultasGerais,
    setParametroPequisado,
    clearParametroPesquisado
}

function tipoConsultaSelecionada(tipoConsultaId) {

    return {
        type: TypesConsultasGerais.TIPOCONSULTA,
        payload: { tipoConsultaSelecionada: tipoConsultaId }
    }
}

function textoConsulta(texto) {

    return {
        type: TypesConsultasGerais.TEXTOCONSULTA,
        payload: { textoConsulta: texto }
    }
}

function setParametroPequisado(texto) {

    return {
        type: TypesConsultasGerais.PARAMETROPESQUISADO,
        payload: { pesquisado: texto }
    }
}

function detalhesConsultasGeraisProcurar(detalhesProcurar) {

    return {
        type: TypesConsultasGerais.DETALHESCONSULTAGERAISPROCURAR,
        payload: { detalhesConsultasGeraisProcurar: detalhesProcurar }
    }
}

function detalhesConsultasGeraisMostrar(detalhesMostrar) {

    return {
        type: TypesConsultasGerais.DETALHESCONSULTAGERAISMOSTRAR,
        payload: { detalhesConsultasGeraisMostrar: detalhesMostrar }
    }
}

function consultasGeraisProcurarResponse(response) {

    return {
        type: TypesConsultasGerais.CONSULTASGERAISPROCURARRESPONSE,
        payload: { response: response }
    }
}

function consultasGeraisMostrarResponse(response) {

    return {
        type: TypesConsultasGerais.CONSULTASGERAISMOSTRARRESPONSE,
        payload: { response: response }
    }
}

function clearConsultasGeraisProcurarResponse() {
    return { type: "CLEARCONSULTASGERAISPROCURARRESPONSE" }
}

function clearConsultasGeraisMostrarResponse() {
    return { type: "CLEARCONSULTASGERAISMOSTRARRESPONSE" }
}

function resetStateConsultasGerais() {
    return { type: "RESETCONSULTASGERAIS" }
}

function clearParametroPesquisado() {
    return { type: "CLEARPARAMETROPESQUISADO" }
}